export enum WhatsappSharingTypeEnum {
    MOBILE_NUMBER = "mobileNumber",
    REFERRING_DOCTOR = "referring_doctor",
}
  